<div class="confirmation-container">
  <div class="wrapper">
    <div class="logo">
      <img
        (click)="vendorClick($event)"
        [src]="vendorLogo"
        [alt]="vendorName"
        width="42px"
        loading="lazy"
      />
    </div>
    <div class="body">
      <div class="subject">
        <div>
          Confirm supplier email for
          <span (click)="vendorClick($event)" class="company-name">{{
            vendorName
          }}</span>
        </div>
        <div class="text-email-block">
          <ng-container *ngIf="supplierEmail; else noSupplierEmailBlock">
            <span
              >Before you can start messaging {{ vendorName }} please confirm
              that the email address (<b>{{ supplierEmail }}</b
              >) for this supplier record is accurate.</span
            >
          </ng-container>
          <ng-template #noSupplierEmailBlock>
            <span
              >Before you can start messaging {{ vendorName }} please add an
              email address for this supplier record.</span
            >
          </ng-template>
        </div>
      </div>
      <div class="actions">
        <ng-container *ngIf="supplierEmail; else noSupplierEmailAction">
          <s-button
            type="secondary"
            size="small"
            [label]="'Edit'"
            [disabled]="isConfirmingEmail"
            (click)="openConfirmationModal($event)"
          >
          </s-button>
          <s-button
            type="primary"
            skin="green"
            size="small"
            [icon]="'pi pi-check-circle'"
            icon="pi pi-check-circle"
            iconPos="left"
            [disabled]="isConfirmingEmail"
            (click)="confirmEmail($event)"
            [label]="'Confirm'"
          >
          </s-button>
        </ng-container>
        <ng-template #noSupplierEmailAction>
          <s-button
            type="primary"
            skin="green"
            size="small"
            [label]="'Add email'"
            (click)="openConfirmationModal($event)"
          >
          </s-button>
        </ng-template>
      </div>
    </div>
  </div>
</div>
